var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HeaderNavContent',[_c('AppLogo'),_c('NavHamburger')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }